(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlh-product-tabs"] && !Shopify.designMode) return;
  try {
    
  /* TLH — onglets produit : changement d'onglet (souris, doigt, clavier) et « Read more » */
  (function () {
    if (!window.customElements || customElements.get('tlh-tabs')) return;

    class TlhTabs extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.addEventListener('click', function (e) {
          var tab = e.target.closest('[role="tab"]');
          if (tab && self.contains(tab)) self.select(tab, false);
          var more = e.target.closest('[data-more]');
          if (more) self.expand(more);
        });
        this.addEventListener('keydown', function (e) {
          var tab = e.target.closest('[role="tab"]');
          if (!tab) return;
          var tabs = Array.prototype.slice.call(self.querySelectorAll('[role="tab"]'));
          var i = tabs.indexOf(tab);
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            self.select(next, true);
          }
        });
        this.clamp();
      }

      select(tab, focus) {
        var tabs = this.querySelectorAll('[role="tab"]');
        for (var i = 0; i < tabs.length; i++) {
          var on = tabs[i] === tab;
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[i].setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        }
        if (focus) tab.focus();
        // seulement si la bande déborde (jamais sur téléphone depuis la grille 2 × 2) : la page ne bouge plus
        var list = this.querySelector('.tlh-tabs__list');
        if (tab.scrollIntoView && list && list.scrollWidth > list.clientWidth + 1) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        this.clamp();
      }

      clamp() {
        var boxes = this.querySelectorAll('[data-clamp]');
        for (var i = 0; i < boxes.length; i++) {
          var box = boxes[i];
          if (box.dataset.expanded === '1') continue;
          var btn = box.parentElement.querySelector('[data-more]');
          box.classList.remove('is-clamped');
          var full = box.scrollHeight;
          box.classList.add('is-clamped');
          var cut = box.clientHeight;
          var needs = full > cut + 24;
          if (!needs) box.classList.remove('is-clamped');
          if (btn) btn.hidden = !needs;
        }
      }

      expand(btn) {
        var box = btn.parentElement.querySelector('[data-clamp]');
        if (!box) return;
        box.dataset.expanded = '1';
        box.classList.remove('is-clamped');
        btn.hidden = true;
      }
    }

    customElements.define('tlh-tabs', TlhTabs);
  })();

  } catch(e) { console.error(e); }
})();
})();
